export default "__VITE_ASSET__BEdz5Zd0__"